
    import './styles.scoped.css';
    export default {
  "calendar": "awsui_calendar_1ykar_1sk0s_93",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1ykar_1sk0s_1",
  "root": "awsui_root_1ykar_1sk0s_124",
  "calendar-inner": "awsui_calendar-inner_1ykar_1sk0s_141",
  "calendar-header": "awsui_calendar-header_1ykar_1sk0s_144",
  "calendar-header-month": "awsui_calendar-header-month_1ykar_1sk0s_149",
  "calendar-next-month-btn": "awsui_calendar-next-month-btn_1ykar_1sk0s_156",
  "calendar-prev-month-btn": "awsui_calendar-prev-month-btn_1ykar_1sk0s_159",
  "calendar-grid": "awsui_calendar-grid_1ykar_1sk0s_162",
  "calendar-grid-cell": "awsui_calendar-grid-cell_1ykar_1sk0s_166",
  "calendar-day-header": "awsui_calendar-day-header_1ykar_1sk0s_172",
  "calendar-day": "awsui_calendar-day_1ykar_1sk0s_172",
  "calendar-day-enabled": "awsui_calendar-day-enabled_1ykar_1sk0s_189",
  "calendar-day-current-month": "awsui_calendar-day-current-month_1ykar_1sk0s_196",
  "calendar-day-selected": "awsui_calendar-day-selected_1ykar_1sk0s_203",
  "calendar-day-today": "awsui_calendar-day-today_1ykar_1sk0s_206",
  "day-inner": "awsui_day-inner_1ykar_1sk0s_221",
  "calendar-week": "awsui_calendar-week_1ykar_1sk0s_286"
};
  